export const faqLinks = {
  contactUs: 'https://support.simcase.tech/l_eng/knowledge_base/?send=question',
};
